export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-29.d7d732c1.png";